import * as React from "react";

function SvgLocalytics(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 52 65.9"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path
        d="M52 0v52H38.3v13.9c-5.5-5.1-10.1-9.4-14.9-13.9H0V0h52zM38.4 9.2v34c1.8.6 3.2.7 4.9-.2V9.4c-1.6-.8-3.1-.6-4.9-.2zm-5 33.9V17.6c-2-.3-3.6-.8-4.8.4v25.3c1.8.4 3.3.7 4.8-.2zM18.7 26.5v16.8c1.9.1 3.4.8 4.9-.4V26.1c-1.8 0-3.3-.4-4.9.4zM8.6 35.1c0 1.4-.1 2.7 0 4 .1 1.4-.4 3 .7 4.2 1.4.4 2.8.6 4.2-.1.8-1.3.5-2.6.4-3.9 0-1.4.4-2.9-.5-4.5-1.3-.2-2.7-.4-4.8.3z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#f05a2b"
      />
    </svg>
  );
}

export default React.forwardRef(SvgLocalytics);
